import { SyntheticEvent, useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router';
import { useTranslation } from 'react-i18next';
import { BottomNavigation, BottomNavigationAction } from '@mui/material';
import { Home, List, LocalShipping, Summarize } from '@mui/icons-material';
import { useDriveOnContext } from '@/contexts/DriveOnContext';

import './BottomNav.css';

export function BottomNav() {
  const driveOnCtx = useDriveOnContext();
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const [value, setValue] = useState<string>('/fooldal'); // FIXME

  useEffect(() => {
    // ha az url olyan, hogy /menetlevel/choosevehicle
    // akkor a /menetlevel-hez tartozo gomb legyen alul aktiv
    function getFirstPart() {
      const end = location.pathname.indexOf('/', 1);
      const result = end === -1 ? location.pathname : location.pathname.substring(0, end);

      return result;
    }

    setValue(getFirstPart());
  }, [location]);

  function isEGSTarget(): boolean {
    if (driveOnCtx.target && driveOnCtx.target.egs) {
      return true;
    }
    return false;
  }

  return (
    <BottomNavigation
      showLabels
      value={value}
      onChange={(_event: SyntheticEvent, newValue: string) => {
        setValue(newValue);
        navigate(newValue);
      }}
    >
      <BottomNavigationAction value="/fooldal" icon={<Home />} label={t('bottomnav.home')} />
      <BottomNavigationAction value="/menetlevel" icon={<LocalShipping />} label={t('bottomnav.menetlevel')} />
      {!isEGSTarget() && <BottomNavigationAction value="/feladataim" icon={<List />} label={t('bottomnav.tasks')} />}
      <BottomNavigationAction value="/report" icon={<Summarize />} label={t('bottomnav.report')} />
    </BottomNavigation>
  );
}
